<section class="banner about-banner">
  <div class="banner-heading-box" data-sal="fade" data-sal-duration ='500' data-sal-delay="300">
    <h1 class="title-sub !mb-0" data-sal="slide-up" data-sal-duration ='500' data-sal-delay="500">
      The Trusted Leader in Global Travel Management
    </h1>
  </div>
</section>
<section>
  <div class="container mx-auto ps-4 border-l border-l-gray-300  section-top-pad section-bottom-pad">
    <div>
      <span class="title-tag-line inline-flex mt-5" data-sal="slide-up" data-sal-duration ='500' data-sal-delay="500">About us</span>
      <h2 class="title-sub mt-3" data-sal="slide-down" data-sal-duration ='500' data-sal-delay="600">
        Redefining Travel Management with Excellence and Innovation.
      </h2>
      <p data-sal="slide-up" data-sal-duration ='500' data-sal-delay="600">Umbrella Travel, we believe that travel should be an experience to cherish, not a hassle to endure. As a trusted leader in travel management, our goal is to simplify the complexities of planning and organizing trips, so you can focus on creating memories that last a lifetime.</p>
    </div>
    <div data-sal="slide-up" data-sal-duration ='500' data-sal-delay="800">
      <a href="" class="butn butn-orange mt-6">Request a Demo<span class="ms-3 icon-arrow-right-long"></span></a>
    </div>
  </div>
</section>
<section class="about-company-section">
  <div class="container mx-auto ps-4 border-l border-l-gray-300  section-top-pad section-bottom-pad">
    <div class="company-section-box">
      <h2 class="title-sub !text-white" data-sal="slide-up" data-sal-duration ='500' data-sal-delay="300">
        Travel smart. Travel happy.<br> Choose Umbrella Travel.
      </h2>
    </div>
    <div class="about-company-wrapper text-white">
      <div class="company-section-box" >
        <h3 class="title-second-sub text-orange-500 my-3" data-sal="slide-up" data-sal-duration ='500' data-sal-delay="300">Who We Are</h3>
        <p data-sal="slide-down" data-sal-duration ='500' data-sal-delay="400">Founded on the principles of reliability and excellence, Umbrella Travel has grown into a dependable partner for travelers worldwide. </p>
      </div>
      <div class="company-section-box">
        <h3 class="title-second-sub text-orange-500 my-3" data-sal="slide-up" data-sal-duration ='500' data-sal-delay="300">What We Do</h3>
        <p data-sal="slide-down" data-sal-duration ='500' data-sal-delay="400"> We provide a full range of travel management services tailored to your unique needs.</p>
      </div>
      <div class="company-section-box">
        <h3 class="title-second-sub text-orange-500 my-3" data-sal="slide-up" data-sal-duration ='500' data-sal-delay="300" >Our Promise</h3>
        <p data-sal="slide-down" data-sal-duration ='500' data-sal-delay="400">At Umbrella Travel, your satisfaction is our top priority. We’re not just about arranging travel; we’re about crafting unforgettable experiences.</p>
      </div>
    </div>
  </div>
</section>
<section class="why-umbrella-section">
  <div class="container mx-auto ps-4 border-l border-l-gray-300  section-top-pad">
    <div class="why-umbrella-wrapper">
      <div>
        <span class="title-tag-line inline-flex mt-5" data-sal="slide-up" data-sal-duration ='500' data-sal-delay="300">Why Choose Us?</span>
        <h2 class="title-sub mt-3" data-sal="slide-down" data-sal-duration ='500' data-sal-delay="400">Experience the Difference with Umbrella Travel</h2>
        <p data-sal="slide-up" data-sal-duration ='500' data-sal-delay="800">We deliver peace of mind. Our dedicated approach ensures every journey is seamless, personalized, and memorable.</p>
        <ul class="space-y-5 text-sm mt-5" >
          <li class="flex items-center gap-x-3" data-sal="slide-up" data-sal-duration ='500' data-sal-delay="500">
            <img src="assets/images/arrow-icon.png" class="w-[40px] h-[40px] min-h-[40px] min-w-[40px]" alt="">
            <div>
              <h2 class="title-second-sub">Expertise Across Industries</h2>

            </div>
          </li>
          <li class="flex items-center gap-x-3" data-sal="slide-up" data-sal-duration ='500' data-sal-delay="600">
            <img src="assets/images/arrow-icon.png" class="w-[40px] h-[40px] min-h-[40px] min-w-[40px]" alt="">
            <div>
              <h2 class="title-second-sub">Real-Time Insights</h2>

            </div>
          </li>
        </ul>
      </div>
      <div>
        <div class="hs-accordion-group">
          <div data-sal="slide-up" data-sal-duration ='500' data-sal-delay="500" class="hs-accordion hs-accordion-active:bg-orange-50 bg-gray-50 mb-2 border border-transparent rounded-xl " id="hs-active-bordered-heading-one">
            <button class="hs-accordion-toggle hs-accordion-active:text-orange-600 inline-flex justify-between items-center gap-x-3 w-full font-semibold text-start text-gray-800 py-4 px-5 hover:text-gray-500 disabled:opacity-50 disabled:pointer-events-none " aria-expanded="false" aria-controls="hs-basic-active-bordered-collapse-one">
              Personalized Service
              <svg class="hs-accordion-active:hidden block size-3.5" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M5 12h14"></path>
                <path d="M12 5v14"></path>
              </svg>
              <svg class="hs-accordion-active:block hidden size-3.5" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M5 12h14"></path>
              </svg>
            </button>
            <div id="hs-basic-active-bordered-collapse-one" class="hs-accordion-content hidden w-full overflow-hidden transition-[height] duration-300" role="region" aria-labelledby="hs-active-bordered-heading-one">
              <div class="pb-4 px-5">
                <p class="text-gray-800 ">
                  Your travel needs are unique, and so is our approach. We listen, adapt, and deliver tailored solutions.
                </p>
              </div>
            </div>
          </div>

          <div data-sal="slide-up" data-sal-duration ='500' data-sal-delay="600" class="hs-accordion hs-accordion-active:bg-orange-50 active bg-gray-50 mb-2 border border-transparent rounded-xl " id="hs-active-bordered-heading-two">
            <button class="hs-accordion-toggle hs-accordion-active:text-orange-600 inline-flex justify-between items-center gap-x-3 w-full font-semibold text-start text-gray-800 py-4 px-5 hover:text-gray-500 disabled:opacity-50 disabled:pointer-events-none " aria-expanded="true" aria-controls="hs-basic-active-bordered-collapse-two">
              Technology-Driven Solutions
              <svg class="hs-accordion-active:hidden block size-3.5" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M5 12h14"></path>
                <path d="M12 5v14"></path>
              </svg>
              <svg class="hs-accordion-active:block hidden size-3.5" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M5 12h14"></path>
              </svg>
            </button>
            <div id="hs-basic-active-bordered-collapse-two" class="hs-accordion-content w-full overflow-hidden transition-[height] duration-300" role="region" aria-labelledby="hs-active-bordered-heading-two">
              <div class="pb-4 px-5">
                <p class="text-gray-800 ">
                  Using the latest tools and technologies, we make travel planning efficient, transparent, and stress-free.
                </p>
              </div>
            </div>
          </div>

          <div data-sal="slide-up" data-sal-duration ='500' data-sal-delay="700" class="hs-accordion hs-accordion-active:bg-orange-50 bg-gray-50 mb-2 border border-transparent rounded-xl " id="hs-active-bordered-heading-three">
            <button class="hs-accordion-toggle hs-accordion-active:text-orange-600 inline-flex justify-between items-center gap-x-3 w-full font-semibold text-start text-gray-800 py-4 px-5 hover:text-gray-500 disabled:opacity-50 disabled:pointer-events-none " aria-expanded="false" aria-controls="hs-basic-active-bordered-collapse-three">
              Global Reach
              <svg class="hs-accordion-active:hidden block size-3.5" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M5 12h14"></path>
                <path d="M12 5v14"></path>
              </svg>
              <svg class="hs-accordion-active:block hidden size-3.5" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M5 12h14"></path>
              </svg>
            </button>
            <div id="hs-basic-active-bordered-collapse-three" class="hs-accordion-content hidden w-full overflow-hidden transition-[height] duration-300" role="region" aria-labelledby="hs-active-bordered-heading-three">
              <div class="pb-4 px-5">
                <p class="text-gray-800 ">
                  Whether it’s a local getaway or an international escapade, our extensive network ensures the best options for every traveler.
                </p>
              </div>
            </div>
          </div>

          <div data-sal="slide-up" data-sal-duration ='500' data-sal-delay="800" class="hs-accordion hs-accordion-active:bg-orange-50 bg-gray-50 mb-2 border border-transparent rounded-xl " id="hs-active-bordered-heading-four">
            <button class="hs-accordion-toggle hs-accordion-active:text-orange-600 inline-flex justify-between items-center gap-x-3 w-full font-semibold text-start text-gray-800 py-4 px-5 hover:text-gray-500 disabled:opacity-50 disabled:pointer-events-none " aria-expanded="false" aria-controls="hs-basic-active-bordered-collapse-three">
              Reliability You Can Trust
              <svg class="hs-accordion-active:hidden block size-3.5" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M5 12h14"></path>
                <path d="M12 5v14"></path>
              </svg>
              <svg class="hs-accordion-active:block hidden size-3.5" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M5 12h14"></path>
              </svg>
            </button>
            <div id="hs-basic-active-bordered-collapse-three" class="hs-accordion-content hidden w-full overflow-hidden transition-[height] duration-300" role="region" aria-labelledby="hs-active-bordered-heading-four">
              <div class="pb-4 px-5">
                <p class="text-gray-800 ">
                  We pride ourselves on being there for you, from the initial inquiry to the final step of your journey.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</section>
